// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Campaign$ReactHooksTemplate = require("../surveys/campaign.res.js");
var ToggleInput$ReactHooksTemplate = require("../common/ToggleInput.res.js");
var CampaignModes$ReactHooksTemplate = require("./campaignModes.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var ConfigurationSettingCard$ReactHooksTemplate = require("../common/ConfigurationSettingCard.res.js");

function CampaignMode$CampaignModeCard(props) {
  var __compact = props.compact;
  var onToggle = props.onToggle;
  var isEnforced = props.isEnforced;
  var isEnabled = props.isEnabled;
  var mode = props.mode;
  var compact = __compact !== undefined ? __compact : false;
  var match;
  switch (mode) {
    case "AnonymousLink" :
        match = [
          "🎭",
          "Anonymous Link",
          "Allow anonymous survey responses"
        ];
        break;
    case "AppLink" :
        match = [
          "📲",
          "App Link",
          "Embed surveys in mobile applications"
        ];
        break;
    case "Email" :
        match = [
          "📧",
          "Email",
          "Send surveys via email with rich HTML templates"
        ];
        break;
    case "Sms" :
        match = [
          "💬",
          "SMS",
          "Deliver quick surveys through text messages"
        ];
        break;
    case "SmsLink" :
        match = [
          "🔗",
          "SMS Link",
          "Share survey links via SMS"
        ];
        break;
    case "Telephonic" :
        match = [
          "📞",
          "Telephonic",
          "Conduct surveys over phone calls"
        ];
        break;
    case "WebsiteLink" :
        match = [
          "🌐",
          "Website Link",
          "Share surveys on your website"
        ];
        break;
    case "WhatsappLink" :
        match = [
          "📱",
          "WhatsApp Link",
          "Distribute surveys through WhatsApp"
        ];
        break;
    default:
      match = [
        "📋",
        mode,
        "Campaign distribution mode"
      ];
  }
  var description = match[2];
  var label = match[1];
  var icon = match[0];
  if (compact) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("span", {
                                        children: icon,
                                        className: "text-base flex-shrink-0 leading-none mt-0.5 " + (
                                          isEnabled ? "" : "opacity-60 grayscale"
                                        )
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("h3", {
                                                        children: label,
                                                        className: "text-sm font-semibold " + (
                                                          isEnabled ? "text-pigmentblue" : "text-aurometalsaurus"
                                                        )
                                                      }),
                                                  isEnabled ? JsxRuntime.jsx(ConfigurationSettingCard$ReactHooksTemplate.statusBadge, {
                                                          enabled: true
                                                        }) : JsxRuntime.jsx(ConfigurationSettingCard$ReactHooksTemplate.statusBadge, {
                                                          enabled: false
                                                        })
                                                ],
                                                className: "flex items-center flex-wrap gap-1.5"
                                              }),
                                          JsxRuntime.jsx("p", {
                                                children: description,
                                                className: "text-xs mt-1 leading-relaxed " + (
                                                  isEnabled ? "text-darkcharcoal" : "text-gray-400"
                                                )
                                              })
                                        ],
                                        className: "min-w-0"
                                      })
                                ],
                                className: "flex items-start gap-2 min-w-0 flex-1"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                      checked: isEnabled,
                                      disabled: isEnforced,
                                      handleChange: (function (param) {
                                          if (isEnforced) {
                                            return ;
                                          } else {
                                            return Curry._1(onToggle, undefined);
                                          }
                                        }),
                                      labelClassName: "flex items-center"
                                    }),
                                className: "flex-shrink-0 pt-0.5"
                              })
                        ],
                        className: "flex items-start justify-between gap-2"
                      }),
                  isEnforced ? JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("span", {
                                        children: "🔒"
                                      }),
                                  JsxRuntime.jsx("span", {
                                        children: "Enforced by administrator",
                                        className: "font-medium"
                                      })
                                ],
                                className: "flex items-center gap-1.5 text-xs text-aurometalsaurus"
                              }),
                          className: "mt-2 pt-2 border-t border-gray-200"
                        }) : null
                ],
                className: ConfigurationSettingCard$ReactHooksTemplate.compactChannelCardClass(isEnforced, isEnabled)
              });
  } else {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("span", {
                                                children: icon,
                                                className: "text-2xl transition-transform duration-200 " + (
                                                  isEnabled ? "scale-110" : "group-hover:scale-105"
                                                )
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("h3", {
                                                        children: label,
                                                        className: "text-lg font-semibold transition-colors " + (
                                                          isEnabled ? "text-blue-900" : "text-gray-900"
                                                        )
                                                      }),
                                                  isEnabled ? JsxRuntime.jsx("span", {
                                                          children: "Active",
                                                          className: "inline-flex items-center px-2 py-0.5 text-xs font-medium text-blue-700 bg-blue-100 rounded-full"
                                                        }) : null
                                                ]
                                              })
                                        ],
                                        className: "flex items-center space-x-3 mb-2"
                                      }),
                                  JsxRuntime.jsx("p", {
                                        children: description,
                                        className: "text-sm mt-2 " + (
                                          isEnabled ? "text-blue-700" : "text-gray-600"
                                        )
                                      })
                                ],
                                className: "flex-1"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                      checked: isEnabled,
                                      disabled: isEnforced,
                                      handleChange: (function (param) {
                                          if (isEnforced) {
                                            return ;
                                          } else {
                                            return Curry._1(onToggle, undefined);
                                          }
                                        }),
                                      labelClassName: "flex items-center"
                                    }),
                                className: "ml-4 flex-shrink-0"
                              })
                        ],
                        className: "flex items-start justify-between"
                      }),
                  isEnforced ? JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("span", {
                                        children: "🔒"
                                      }),
                                  JsxRuntime.jsx("span", {
                                        children: "Enforced by administrator",
                                        className: "font-medium"
                                      })
                                ],
                                className: "flex items-center space-x-2 text-xs text-gray-500"
                              }),
                          className: "mt-3 pt-3 border-t border-gray-200"
                        }) : null
                ],
                className: "group relative bg-white border-2 rounded-xl p-5 transition-all duration-200 " + (
                  isEnabled ? "border-blue-200 bg-blue-50 shadow-sm hover:shadow" : "border-gray-200 hover:border-gray-300 hover:shadow-sm"
                )
              });
  }
}

var CampaignModeCard = {
  make: CampaignMode$CampaignModeCard
};

function CampaignMode(props) {
  var __compact = props.compact;
  var onChange = props.onChange;
  var enforced = props.enforced;
  var enforce = props.enforce;
  var setting = props.setting;
  var compact = __compact !== undefined ? __compact : false;
  var enabledCount = Belt_List.length(CampaignModes$ReactHooksTemplate.value(setting));
  var totalCount = Belt_List.length(Campaign$ReactHooksTemplate.availableCampaignModes);
  var headerPadding = compact ? "p-4" : "px-6 py-5";
  var bodyPadding = compact ? "p-4" : "p-6";
  var titleClass = compact ? "text-sm font-semibold text-darkcharcoal" : "text-xl font-bold text-gray-900";
  var sectionTitle = compact ? "Distribution Channels" : "Campaign Distribution Modes";
  var outerClass = compact ? ConfigurationSettingCard$ReactHooksTemplate.compactSectionClass(enforced) : "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden min-w-0";
  var headerClass = compact ? "border-b border-gray-200 " + headerPadding : "bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-100 " + headerPadding;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: compact ? JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("h2", {
                                                      children: sectionTitle,
                                                      className: titleClass
                                                    }),
                                                JsxRuntime.jsx("span", {
                                                      children: String(enabledCount) + " / " + String(totalCount) + " active",
                                                      className: "px-2 py-0.5 text-xs font-semibold text-pigmentblue bg-lavenderweb rounded-full"
                                                    })
                                              ],
                                              className: "flex flex-wrap items-center gap-2"
                                            }),
                                        JsxRuntime.jsx("p", {
                                              children: "Enable or disable distribution channels for this campaign",
                                              className: "text-xs text-aurometalsaurus mt-1"
                                            })
                                      ]
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                            checked: enforce,
                                            disabled: enforced,
                                            label: "Enforce Policy",
                                            handleChange: (function (param) {
                                                if (!enforced) {
                                                  return Curry._2(onChange, {
                                                              TAG: "CampaignModes",
                                                              _0: setting
                                                            }, !enforce);
                                                }
                                                
                                              }),
                                            checkboxClassName: "custom_checkbox",
                                            labelClassName: "text-xs font-medium text-darkcharcoal"
                                          }),
                                      className: "pt-3 border-t border-gray-200"
                                    })
                              ],
                              className: "flex flex-col gap-3"
                            }) : JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("h2", {
                                                      children: sectionTitle,
                                                      className: titleClass
                                                    }),
                                                JsxRuntime.jsx("span", {
                                                      children: String(enabledCount) + " / " + String(totalCount) + " Active",
                                                      className: "px-2.5 py-1 text-xs font-bold text-blue-700 bg-blue-100 rounded-full"
                                                    })
                                              ],
                                              className: "flex flex-wrap items-center gap-2 mb-1"
                                            }),
                                        JsxRuntime.jsx("p", {
                                              children: "Enable or disable distribution channels for your campaigns",
                                              className: "text-sm text-gray-600"
                                            })
                                      ],
                                      className: "flex-1 min-w-0"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                  checked: enforce,
                                                  disabled: enforced,
                                                  label: "Enforce Policy",
                                                  handleChange: (function (param) {
                                                      if (!enforced) {
                                                        return Curry._2(onChange, {
                                                                    TAG: "CampaignModes",
                                                                    _0: setting
                                                                  }, !enforce);
                                                      }
                                                      
                                                    }),
                                                  checkboxClassName: "custom_checkbox",
                                                  labelClassName: "text-sm font-medium text-gray-700 whitespace-nowrap"
                                                }),
                                            className: "flex items-center space-x-2 px-4 py-2 rounded-lg " + (
                                              enforce ? "bg-blue-50 border border-blue-200" : "bg-white border border-gray-200"
                                            )
                                          }),
                                      className: "flex-shrink-0"
                                    })
                              ],
                              className: "flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4"
                            }),
                      className: headerClass
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: $$Array.of_list(Belt_List.map(Campaign$ReactHooksTemplate.availableCampaignModes, (function (mode) {
                                          var isEnabled = Belt_List.has(CampaignModes$ReactHooksTemplate.value(setting), mode, (function (a, b) {
                                                  return a === b;
                                                }));
                                          return JsxRuntime.jsx(CampaignMode$CampaignModeCard, {
                                                      mode: mode,
                                                      isEnabled: isEnabled,
                                                      isEnforced: enforced,
                                                      onToggle: (function (param) {
                                                          var mode$1 = Belt_List.has(CampaignModes$ReactHooksTemplate.value(setting), mode, (function (a, b) {
                                                                  return a === b;
                                                                }));
                                                          var addCampaignMode = mode$1 ? Belt_List.keep(CampaignModes$ReactHooksTemplate.value(setting), (function (a) {
                                                                    return a !== mode;
                                                                  })) : Belt_List.add(CampaignModes$ReactHooksTemplate.value(setting), mode);
                                                          var updateSettings = CampaignModes$ReactHooksTemplate.setValue(setting, addCampaignMode);
                                                          Curry._2(onChange, {
                                                                TAG: "CampaignModes",
                                                                _0: updateSettings
                                                              }, enforce);
                                                        }),
                                                      compact: compact
                                                    }, mode);
                                        }))),
                              className: compact ? "grid grid-cols-1 gap-3" : "grid grid-cols-1 md:grid-cols-2 gap-4"
                            }),
                        enforced ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("span", {
                                              children: "⚠️",
                                              className: compact ? "text-sm flex-shrink-0" : "text-lg flex-shrink-0"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("h4", {
                                                      children: "Policy Enforcement Active",
                                                      className: "text-sm font-semibold text-amber-900 mb-0.5"
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: "These settings are enforced and cannot be modified. Contact your administrator for changes.",
                                                      className: "text-xs text-amber-800"
                                                    })
                                              ]
                                            })
                                      ],
                                      className: "flex items-start space-x-2"
                                    }),
                                className: (
                                  compact ? "mt-4 p-3" : "mt-6 p-4"
                                ) + " bg-amber-50 border border-amber-200 rounded-lg"
                              }) : null
                      ],
                      className: bodyPadding
                    })
              ],
              className: outerClass
            });
}

var make = CampaignMode;

exports.CampaignModeCard = CampaignModeCard;
exports.make = make;
/* react/jsx-runtime Not a pure module */
